import { createSlice } from '@reduxjs/toolkit';
import {
  addGoalItem,
  deleteGoalItem,
  editGoalItem,
  getGoalCategories,
  getGoalItem,
  patchGoalItem,
  selectBoxTemplate,
  updateCategory,
} from './goalsActions';

const initialState = {
  isLoading: false,
  loading: false,
  archived: false,
  categories: null,
  error: null,
  success: false,
  selectedGoal: null,
  filteredArchives: null,
};

const goalsSlice = createSlice({
  name: 'goals',
  initialState,
  reducers: {
    setArchiveFilter: (state, { payload }) => {
      state.filteredArchives = payload;
    },
    setSelectedGoal: (state, { payload }) => {
      state.selectedGoal = payload;
    },
    toggleArchive: state => {
      state.archived = !state.archived;
    },
  },
  extraReducers: {
    // get categories
    [getGoalCategories.pending]: state => {
      state.loading = true;
    },
    [getGoalCategories.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.categories = payload.data;
    },
    [getGoalCategories.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
    // select 4boxes template
    [selectBoxTemplate.pending]: state => {
      state.isLoading = true;
    },
    [selectBoxTemplate.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.categories = payload.data;
    },
    [selectBoxTemplate.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
    },
    // update category
    [updateCategory.pending]: state => {
      state.loading = true;
    },
    [updateCategory.fulfilled]: (state, action) => {
      state.loading = false;
      state.categories = state.categories.map(cat => {
        if (cat.id === action.meta.arg.goalCategoryId) {
          return {
            ...cat,
            title: action.meta.arg.goalCategory,
          };
        }

        return cat;
      });
    },
    [updateCategory.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
    // add goal item
    [addGoalItem.pending]: state => {
      state.loading = true;
    },
    [addGoalItem.fulfilled]: (state, action) => {
      state.loading = false;
    },
    [addGoalItem.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
    // get goal item
    [getGoalItem.pending]: state => {
      state.loading = true;
    },
    [getGoalItem.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.categories =
        state.categories && state.categories.length > 0
          ? state.categories.map(cat => {
              if (cat.id === payload.goalCategoryId) {
                return {
                  ...cat,
                  goals: [
                    ...cat.goals.map(goal => {
                      if (goal.id === payload.id) {
                        return payload;
                      }
                      return goal;
                    }),
                  ],
                };
              }

              return cat;
            })
          : state.categories;
    },
    [getGoalItem.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
    // update goal item
    [editGoalItem.pending]: state => {
      state.loading = true;
    },
    [editGoalItem.fulfilled]: (state, action) => {
      state.loading = false;
    },
    [editGoalItem.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
    // patch goal item
    [patchGoalItem.pending]: state => {
      state.loading = true;
    },
    [patchGoalItem.fulfilled]: (state, action) => {
      state.loading = false;
    },
    [patchGoalItem.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
    // delete goal item
    [deleteGoalItem.pending]: state => {
      state.loading = true;
    },
    [deleteGoalItem.fulfilled]: (state, action) => {
      state.loading = false;
    },
    [deleteGoalItem.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
  },
});

export const { toggleArchive, setSelectedGoal, setArchiveFilter } =
  goalsSlice.actions;
export default goalsSlice.reducer;
